import { useMemo } from "react";
import { apiResolver, useApi } from "@/api/useApi";
import {
  CreateGdprEventRequest,
  CreateGdprEventResponse,
  GetTenantGdprEventsResponse,
} from "./GdprEvent.model";

export function useGdprEventApi() {
  const { api } = useApi();

  return useMemo(
    () => ({
      createGdprEvent: (data: CreateGdprEventRequest) =>
        apiResolver<CreateGdprEventResponse>(api.post("/platform/gdpr-events", data)),
      getTenantGdprEvents: () =>
        apiResolver<GetTenantGdprEventsResponse>(api.get("/platform/gdpr-events")),
    }),
    [api]
  );
}

